import FormattedList from 'I18n/components/FormattedList';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import TeamName from 'automation-ui-references/customer-data/TeamName';
import UserName from 'automation-ui-references/customer-data/UserName';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const InAppNotificationActionDetail = ({
  actionMetadata,
  flowObjectTypeId,
  messageLangPath = 'actionDetail'
}) => {
  const {
    body,
    subject,
    userIds,
    teamIds,
    ownerProperties
  } = actionMetadata;
  const renderSubject = () => {
    // Hybrid classic flows only have one message field, which is interpreted as "body"
    const message = subject || body;
    return message ? /*#__PURE__*/_jsx(Text, {
      typography: "body-125",
      children: /*#__PURE__*/_jsx(PersonalizedTextView, {
        propertyTypeId: flowObjectTypeId,
        text: `"${message}"`
      })
    }) : /*#__PURE__*/_jsx(MissingLabel, {
      type: "subject"
    });
  };
  const renderRecipients = () => {
    const userIdRecipients = userIds || [];
    const teamIdRecipients = teamIds || [];
    const ownerRecipients = ownerProperties || [];
    if (!userIdRecipients.length && !teamIdRecipients.length && !ownerRecipients.length) {
      return /*#__PURE__*/_jsx(MissingLabel, {
        type: "recipient"
      });
    }
    const recipientList = teamIdRecipients.map(teamId => /*#__PURE__*/_jsx(TeamName, {
      id: teamId
    }, `team-${teamId}`)).concat(userIdRecipients.map(userId => /*#__PURE__*/_jsx(UserName, {
      id: userId
    }, `user-${userId}`))).concat(ownerRecipients.map(propertyName => /*#__PURE__*/_jsx(PropertyName, {
      objectTypeId: flowObjectTypeId,
      propertyName: propertyName
    }, `property-${propertyName}`)));
    return /*#__PURE__*/_jsx(FormattedList, {
      children: recipientList
    });
  };
  return /*#__PURE__*/_jsx("div", {
    children: messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.in-app-notification.action-detail",
      options: {
        recipients: renderRecipients(),
        subject: renderSubject()
      }
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.in-app-notification.action-preview",
      options: {
        recipients: renderRecipients(),
        subject: renderSubject()
      }
    })
  });
};
export default InAppNotificationActionDetail;